import React, { InputHTMLAttributes, ReactNode } from 'react';
import InputFrame from '../atoms/InputFrame';

interface TextEditProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
    label: string;
    errorMessage?: string;
    helperText?: string;
    className?: string;
    labelClassName?: string;
    prefix?: ReactNode;
}

const TextEdit: React.FC<TextEditProps> = ({ prefix, label, errorMessage, helperText, className, labelClassName, ...restProps }) => {

    let textColor = "text-gray-900 dark:text-gray-100";
    let focusColor = "focus:border-blue-600 dark:focus:border-blue-400";

    if (errorMessage) {
        textColor = "text-red-700 dark:text-red-400";
        focusColor = "focus:border-red-600 dark:focus:border-red-400";
    }

    return (
        <div>
            <InputFrame
                label={label}
                /* o `id` já ia para o input e o rótulo ficava solto: sem `htmlFor` o leitor de
                   tela não anuncia o nome do campo e clicar no texto não foca nada. Quem não
                   passa `id` continua como antes (ver InputFrame). */
                htmlFor={restProps.id}
                errorMessage={errorMessage}
                className={className}
                prefix={prefix}
                textColor={textColor}
                labelClassName={labelClassName}
            >
                <input
                    className={`block py-2.5 px-0 w-full text-sm ${textColor} bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 ${focusColor} peer disabled:opacity-50 disabled:cursor-not-allowed dark:text-white`}
                    placeholder=" "
                    {...restProps}
                />
            </InputFrame>
            {helperText && !errorMessage && (
                <p className="text-xs text-gray-500 mt-1 dark:text-gray-400">
                    {helperText}
                </p>
            )}
        </div>
    );
};

export default TextEdit;